export const VISIBILITY_OPTIONS = [
  {
    name: 'NEVER',
    value: 'NEVER',
    label: 'admin.customForms.clientVisibility.noClients'
  },
  {
    name: 'ALL',
    value: 'ALL',
    label: 'admin.customForms.clientVisibility.allClients'
  },
  {
    name: 'SPECIFIC',
    value: 'SPECIFIC',
    label: 'admin.customForms.clientVisibility.specificClients'
  }
];
